import { useStore } from '~/common/js/patch';  
import {
  prefixUrlImg,
  convertAmount,
  // hasLogin,
  convertCoinMoneyAmount,
  dealZendeskUrl,
  numbroUtil,
  // setUserInfoInApp,
} from '@/common/js/utils.js';
import {
  exchangeCurrency,
  exchangeCurrencyByCoin,
} from '@/frontend-shared/helper/util';
import { setAppLoginInfo } from '~/common/js/storeUtil';
import { track, SENSOR_EVENT_NAME } from '~/common/js/sensor';
const trackPre = (params: any, datas: any) => {
  console.log('🚀 sensor done', params, datas);
  return track(params, datas);
};
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.mixin({
    methods: {
      // 根据域名添加图片url前缀
      prefixUrlImg,
      // 根据当前语言汇率换算当前语言的价格
      convertAmount,
      // 是否登录的promise
      // hasLogin,
      // 转换币种价格精度，大于2，保持不变，小于2，增加0补位
      convertCoinMoneyAmount,
      // // 根据当前汇率换算价格（对应美元->法币汇率）
      exchangeCurrency,
      // // 根据当前汇率换算价格（对应计价币，讲价币->美元->法币汇率）
      exchangeCurrencyByCoin,
      // setUserInfoInApp,
      // 处理zendeskUrl
      dealZendeskUrl,
      $numbro: (val: string | number, format = '', upperCase: boolean) => numbroUtil(val, format, upperCase),
      /**
       * 登录，兼容网页和APP内嵌，
       * APP内嵌，非Promise，在登录结束后不管成功还是失败都会调用loginCallback，根据success判断
       * APP内嵌，是Promise，在登录结束后成功走then，失败走catch
       * @param { boolean } options.updateUserInfo 登录成功后主动请求接口更新用户信息
       * @param { string } options.exLogin 非App内嵌页面可以指定跳转的特殊登录页面
       */
      $toLogin(options = {}, loginCallback) {
        console.log('$toLogin', options, loginCallback);
        const isPromise = !loginCallback || typeof loginCallback !== 'function';
        const isApp = !!window.jsBridge;
        const loginFn = (resolve, reject) => {
          if (this.$route.name === 'login-lang') {
            return;
          }
          if (isApp && window.jsBridge?.toLogin) {
            import('amfe-env').then((env) => {
              let toLoginFn;
              if (env.os.isIOS) {
                // ios 直接使用 window.jsBridge.toLogin
                toLoginFn = (callback) => {
                  window.jsBridge.toLogin(callback);
                };
              } else {
                // android
                toLoginFn = (callback) => {
                  window.jsBridge.invoke('toLogin', { backPage: 'origin' }, callback);
                };
              }
              toLoginFn((params) => {
                // 健壮代码，ios的JSON解析不合法
                // 以后可以移除
                params = params.replace(/(Optional\("(.*)"\)\))/, '$2');
                const paramsObj = JSON.parse(params);
                if (paramsObj?.success) {
                  setAppLoginInfo(options.store, paramsObj);
                  if (options.updateUserInfo && options.store) {
                    console.log('account/getUserSecInfo', options.store);
                    options.store?.dispatch('account/getUserSecInfo');
                  }
                  isPromise
                    ? resolve(paramsObj)
                    : loginCallback({
                        userInfo: paramsObj,
                        success: true,
                      });
                } else {
                  isPromise
                    ? reject()
                    : loginCallback({
                        success: false,
                      });
                }
              });
            });
          } else {
            const store = useStore();
            const routeParam = {
              name: options.exLogin ? options.exLogin : 'login-lang',
              params: {
                lang: options.store?.locale || store?.locale ||'en',
              },
              query: {
                goto: this.$route.name,
                routeParams: JSON.stringify(this.$route.params),
              },
            };

            if (this.$route.query) {
              routeParam.query.others = JSON.stringify(this.$route.query);
            }
            this.$router.push(routeParam);
          }
        };
        if (isPromise) {
          return new Promise((resolve, reject) => {
            loginFn(resolve, reject);
          });
        } else {
          loginFn();
        }
      },
      /**
       * 检测登录，兼容网页和APP内嵌，
       * APP内嵌，非Promise，在登录结束后不管成功还是失败都会调用loginCallback，根据success判断
       * APP内嵌，是Promise，在登录结束后成功走then，失败走catch
       * @param { boolean } options.autoLogin 未登录情况下是否要走登录流程
       * @param { boolean } options.loginSuccess 登陆成功后的回调，autoLogin为true才会触发
       * @param { boolean } options.updateUserInfo 登录成功后主动请求接口更新用户信息，autoLogin为true才会触发
       * @param { string } options.exLogin 非App内嵌页面可以指定跳转的特殊登录页面
       */
      $checkLogin(options = {}, checkCallback) {
        const isPromise = !checkCallback || typeof checkCallback !== 'function';

        const isApp = !!window.jsBridge;

        const callBack = (res, promiseBack) => {
          const prams = {
            toLogin: this.$toLogin.bind(
              this,
              { updateUserInfo: !!options.updateUserInfo, exLogin: options.exLogin, store: options.store },
              options.loginSuccess
            ),
            ...res,
          };
          if (isPromise) {
            promiseBack(prams);
          } else {
            checkCallback(prams);
          }
        };

        const toCheck = (resolve, reject) => {
          if (isLoginedToken()) {
            // 返回已登录
            callBack({ hasLogin: true }, resolve);
          } else if (isApp && window.jsBridge.getUserSession) {
            window.jsBridge.getUserSession((retData) => {
              // 20220330 IOS端返回的JSON中多了个Optional，需要临时处理一下
              // 影响面涉及：安卓和ios以及其他环境
              // 后续需要移除
              retData = retData.replace(/(Optional\("(.*)"\)\))/, '$2');
              const retObj = JSON.parse(retData);
              if (retObj?.success) {
                // 返回已登录
                callBack({ hasLogin: true, userInfo: retObj }, resolve);
              } else {
                // app 未登录
                if (options.autoLogin) {
                  this.$toLogin(
                    { updateUserInfo: !!options.updateUserInfo, exLogin: options.exLogin, store: options.store },
                    options.loginSuccess
                  );
                } else {
                  callBack({ hasLogin: false }, reject);
                }
              }
            });
          } else {
            // web未登录
            if (options.autoLogin) {
              this.$toLogin(
                { updateUserInfo: !!options.updateUserInfo, exLogin: options.exLogin, store: options.store },
                options.loginSuccess
              );
            } else {
              callBack({ hasLogin: false }, reject);
            }
          }
        };

        if (isPromise) {
          return new Promise((resolve, reject) => {
            toCheck(resolve, reject);
          });
        } else {
          toCheck();
        }
      },
    },
  });

  return {
    provide: {
      sensor: {
        track: trackPre,
        SENSOR_EVENT_NAME,
      },
    },
  };
});
